import React, { Fragment, useState, useEffect, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";

import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import FormLabel from "@material-ui/core/FormLabel";
import Divider from "@material-ui/core/Divider";
import Alert from "@material-ui/lab/Alert";

import { Business, GpsFixed } from "@material-ui/icons";
import axios from "axios";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Snackbar from "@material-ui/core/Snackbar";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import DateFnsUtils from "@date-io/date-fns";
import format from "date-fns/format";
import deLocale from "date-fns/locale/es";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import Slide from "@material-ui/core/Slide";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Skeleton from "@material-ui/lab/Skeleton";

// SELECT
import LoadCiudades from "components/services/LoadCiudades_conecta2";
import LoadRecyclerType from "components/services/LoadRecyclerType";

import MapDraggableMarker from "views/Maps/MapDraggableMarker";

import { cardStyle } from "assets/jss/material-dashboard-react/components/cardStyle";

const useStyles = makeStyles(cardStyle);

export default function MyRegistration() {
  const classes = useStyles();
  const [loader, setLoader] = useState(true);
  const [openAlertsuccess, setOpenAlertsuccess] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [mensaje_error, setMensaje_error] = useState("");
  const [openBackdrop, setoOpenBackdrop] = useState(false);
  const [mensaje_success, setMensaje_success] = useState("");
  const [errorServer, setErrorServer] = useState(false);

  let keyAuthorization = localStorage.getItem("Session");

  const { urlServices, keyAplication } = useContext(UrlServicesContext);

  const [values, setValues] = useState({
    stakeholder_id: "",
    descriptionRecycler: "",
    nameRecycler: "",
    cityRecycler: "",
    cityRecyclerData: "",
    latitude: -0.18093079060265435,
    longitude: -78.46778869628906,
    actorType: "",
    actorTypeData: "",
    dateStartRecyclerSave: "",
    dateStartRecycler: null,
    addressRecycler: "",
    womanNumber: "",
    menNumber: "",
    errorFieldCity: false,
    errorGenderContact: false,
    errorFieldactorType: false,
    errorFieldWomanNumber: false,
    errorFieldMenNumber: false,
    errorDateStartRecycler: false,
    errorFieldnameRecycler: false,
    errorFielddescriptionRecycler: false,
    errorFieldaddressRecycler: false,
  });

  const [dataLtLgCiudad, setDataLtLgCiudad] = useState({
    lt: -0.18093079060265435,
    lg: -78.46778869628906,
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    axios
      .get(`${urlServices}stakeholders/user/${localStorage.getItem("id")}`, {
        headers: {
          application: keyAplication,
        },
      })
      .then(
        (response) => {
          if (response.status === 200) {
            setValues({
              ...values,
              stakeholder_id: response.data.id,
              descriptionRecycler: response.data.description,
              nameRecycler: response.data.stakeholder_name,
              cityRecycler: response.data.city_id,
              cityRecyclerData: {
                id: response.data.city_id,
                nombre: response.data.city_name,
              },
              latitude: response.data.lat,
              longitude: response.data.lon,
              actorType: response.data.recycler_type_id,
              actorTypeData: {
                id: response.data.recycler_type_id,
                detailName: response.data.recycler_type_name,
              },
              dateStartRecycler: response.data.started_at,
              dateStartRecyclerSave: response.data.started_at,
              addressRecycler: response.data.address,
              womanNumber: response.data.working_women,
              menNumber: response.data.working_men,
              genderContactData: {
                id: response.data.gender_id,
                detailName: response.data.gender_name,
              },
            });

            setDataLtLgCiudad({ lt: response.data.lat, lg: response.data.lon });

            setLoader(false);
          }
        },
        (error) => {
          console.log(error);
          setErrorServer(true);
        }
      );
  }, [urlServices, keyAplication]);

  const handleChange = (prop) => (event) => {
    setValues({
      ...values,
      [prop]: event.target.value,
      errorFieldnameRecycler: false,
      errorFieldMenNumber: false,
      errorFielddescriptionRecycler: false,
      errorFieldaddressRecycler: false,
      errorFieldWomanNumber: false,
    });
  };

  const getResponseActorType = (pro) => {
    if (pro !== null) {
      setValues({
        ...values,
        actorType: pro.code,
        actorTypeData: pro,
        errorFieldactorType: false,
      });
    } else {
      setValues({
        ...values,
        actorType: "",
        actorTypeData: pro,
      });
    }
  };

  const getResponseCityRecycler = (pro) => {
    if (pro !== null) {
      setValues({
        ...values,
        cityRecycler: pro.id,
        cityRecyclerData: pro,
        errorFieldCity: false,
      });
      setDataLtLgCiudad({ lt: pro.latitud, lg: pro.longitud });
    } else {
      setValues({
        ...values,
        cityRecycler: "",
        cityRecyclerData: pro,
      });
      setDataLtLgCiudad({ lt: -0.18093079060265435, lg: -78.46778869628906 });
    }
  };

  const handleChangeDateStartRecycler = (date) => {
    setValues({
      ...values,
      dateStartRecycler: date,
      errorDateStartRecycler: false,
    });
  };

  const getResponselt = (latitude) => {
    setValues({ ...values, latitude: latitude });
  };

  const getResponselng = (longitude) => {
    setValues({ ...values, longitude: longitude });
  };

  const handleClose = (event, reason) => {
    setOpenAlert(false);
    setOpenAlertsuccess(false);
  };

  const submitForm = (e) => {
    e.preventDefault();

    setOpenAlertsuccess(false);

    if (values.nameRecycler.length === 0) {
      setValues({
        ...values,
        errorFieldnameRecycler: true,
      });
      setMensaje_error('El campo "Nombre del reciclador" es obligatorio!');
      setOpenAlert(true);
      setoOpenBackdrop(false);
    } else if (values.descriptionRecycler.length === 0) {
      setValues({
        ...values,
        errorFielddescriptionRecycler: true,
      });
      setMensaje_error('El campo "Descripción" es obligatorio!');
      setOpenAlert(true);
      setoOpenBackdrop(false);
    } else if (values.cityRecycler === "") {
      setValues({
        ...values,
        errorFieldCity: true,
      });
      setMensaje_error('Seleccione una opción en "Ciudades"');
      setOpenAlert(true);
      setoOpenBackdrop(false);
    } else if (values.addressRecycler.length === 0) {
      setValues({
        ...values,
        errorFieldaddressRecycler: true,
      });
      setMensaje_error('El campo "Dirección" es obligatorio!');
      setOpenAlert(true);
      setoOpenBackdrop(false);
    } else if (values.womanNumber.length === 0) {
      setValues({
        ...values,
        errorFieldWomanNumber: true,
      });
      setMensaje_error("Número de mujeres es obligatorio!");
      setOpenAlert(true);
      setoOpenBackdrop(false);
    } else if (values.menNumber.length === 0) {
      setValues({
        ...values,
        errorFieldMenNumber: true,
      });
      setMensaje_error("Número de hombres es obligatorio!");
      setOpenAlert(true);
      setoOpenBackdrop(false);
    } else if (values.actorType === "") {
      setValues({
        ...values,
        errorFieldactorType: true,
      });
      setMensaje_error('Seleccione una opción en "Tipo de actor"');
      setOpenAlert(true);
      setoOpenBackdrop(false);
    } else if (values.dateStartRecycler === null) {
      setValues({
        ...values,
        errorDateStartRecycler: true,
      });
      setMensaje_error('El campo "Fecha de Inicio" es obligatorio!');
      setOpenAlert(true);
      setoOpenBackdrop(false);
    } else {
      setoOpenBackdrop(true);

      const dataValues = {
        stakeholder_name: values.nameRecycler,
        description: values.descriptionRecycler,
        address: values.addressRecycler,
        lat: values.latitude,
        lon: values.longitude,
        city_id: values.cityRecycler,
        city_another: "0",
        recycler_type_id: values.actorType,
        working_men: values.menNumber,
        working_women: values.womanNumber,
      };

      if (values.dateStartRecyclerSave !== values.dateStartRecycler) {
        dataValues.started_at = format(values.dateStartRecycler, "yyyy-MM-dd");
      }

      axios
        .put(
          `${urlServices}stakeholders/${values.stakeholder_id}`,
          dataValues,
          {
            headers: {
              application: keyAplication,
              Authorization: "Bearer " + keyAuthorization,
            },
          }
        )
        .then((response) => {
          if (response.status === 200) {
            setOpenAlertsuccess(true);
            setMensaje_success("Registro guardado con exito!");
            setoOpenBackdrop(false);
          }
        })
        .catch((e) => {
          if (e.response.status === 402) {
            setMensaje_error("Error al registrar los datos");
            setOpenAlert(true);
            setoOpenBackdrop(false);
          } else {
            setMensaje_error("Error al registrar los datos");
            setOpenAlert(true);
            console.log(e);
            setoOpenBackdrop(false);
          }
        });
    }
  };

  return (
    <Fragment>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card chart>
            <CardBody>
              <Grid container spacing={2} className={classes.containerStyle}>
                <Grid item xs={12} sm={12} style={{ marginTop: 10 }}>
                  <div className={classes.titleCardSub2}>
                    <Business className={classes.iconSubTitle} />
                    DATOS DEL RECICLADOR, EMPRESA U ORGANIZACIÓN DE RECICLAJE
                  </div>
                  <Divider variant="fullWidth" style={{ marginBottom: "4%" }} />
                </Grid>
                <Grid item xs={12} sm={12}>
                  {errorServer ? (
                    <Alert severity="error">
                      Error en la consulta al servidor
                    </Alert>
                  ) : (
                    ""
                  )}
                </Grid>
                {loader ? (
                  <Fragment>
                    <Grid item xs={12} md={6}>
                      <Skeleton height={40} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Skeleton height={40} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Skeleton height={40} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Skeleton height={40} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Skeleton height={40} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Skeleton height={40} />
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <center>
                        <Skeleton width={120} height={40} />
                      </center>
                    </Grid>
                  </Fragment>
                ) : (
                  <Fragment>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        name="nameRecycler"
                        value={values.nameRecycler}
                        error={values.errorFieldnameRecycler}
                        onChange={handleChange("nameRecycler")}
                        fullWidth
                        required
                        inputProps={{ maxLength: 100 }}
                        autoComplete="off"
                        label="Reciclador / organización / empresa"
                        helperText="Nombre"
                        margin="dense"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        name="descriptionRecycler"
                        value={values.descriptionRecycler}
                        error={values.errorFielddescriptionRecycler}
                        onChange={handleChange("descriptionRecycler")}
                        fullWidth
                        required
                        inputProps={{ maxLength: 150 }}
                        autoComplete="off"
                        label="Breve descripción"
                        //helperText="Error"
                        margin="dense"
                        //rows="3"
                        multiline
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <LoadCiudades
                        callback={getResponseCityRecycler}
                        value={values.cityRecyclerData}
                        error={values.errorFieldCity}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        name="addressRecycler"
                        value={values.addressRecycler}
                        error={values.errorFieldaddressRecycler}
                        onChange={handleChange("addressRecycler")}
                        fullWidth
                        required
                        inputProps={{ maxLength: 150 }}
                        autoComplete="off"
                        label="Dirección del proyecto"
                        //helperText="Error"
                        margin="dense"
                        //rows="3"
                        multiline
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        error={values.errorFieldWomanNumber}
                        name="womanNumber"
                        value={values.womanNumber}
                        onChange={handleChange("womanNumber")}
                        fullWidth
                        required
                        inputProps={{ maxLength: 12 }}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );
                        }}
                        autoComplete="off"
                        label="Mujeres que trabajan en el proyecto"
                        margin="dense"
                        helperText="Cantidad"
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        error={values.errorFieldMenNumber}
                        name="menNumber"
                        value={values.menNumber}
                        onChange={handleChange("menNumber")}
                        fullWidth
                        required
                        inputProps={{ maxLength: 12 }}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );
                        }}
                        autoComplete="off"
                        label="Hombres que trabajan en el proyecto"
                        margin="dense"
                        helperText="Cantidad"
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <LoadRecyclerType
                        callback={getResponseActorType}
                        value={values.actorTypeData}
                        error={values.errorFieldactorType}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <MuiPickersUtilsProvider
                        locale={deLocale}
                        utils={DateFnsUtils}
                      >
                        <KeyboardDatePicker
                          // disableToolbar
                          //  disabled={disabled}
                          error={values.errorDateStartRecycler}
                          variant="inline"
                          format="dd/MM/yyyy"
                          margin="dense"
                          openTo="year"
                          autoOk={true}
                          id="dateStartRecycler"
                          autoComplete="off"
                          label="Fecha de inicio del proyecto"
                          value={values.dateStartRecycler}
                          onChange={handleChangeDateStartRecycler}
                          KeyboardButtonProps={{
                            "aria-label": "change date",
                          }}
                          style={{ width: "100%" }}
                        />
                      </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item xs={12} md={12} className={classes.mapStyle}>
                      <FormLabel component="legend">
                        <div className={classes.fontParagraph}>
                          <GpsFixed /> Habilita la ubicación de tu navegador.
                          <br></br>
                          Por favor, seleccione el puntero rojo y arrastre hasta
                          la ubicación del proyecto.
                        </div>
                      </FormLabel>

                      <MapDraggableMarker
                        callbacklt={getResponselt}
                        callbacklng={getResponselng}
                        dataltlg={dataLtLgCiudad}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} style={{ margin: "70px 0" }}>
                      <center>
                        {openAlertsuccess ? (
                          <Alert severity="success">{mensaje_success}</Alert>
                        ) : (
                          ""
                        )}
                        <br></br>
                        <Button
                          onClick={submitForm}
                          className={classes.buttonSubmit}
                        >
                          Guardar
                        </Button>
                      </center>
                    </Grid>
                  </Fragment>
                )}
              </Grid>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      <Backdrop
        style={{ zIndex: "9999", color: "#FFFFFF" }}
        open={openBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={openAlert}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={handleClose}
      >
        <Slide direction="up" in={openAlert} mountOnEnter unmountOnExit>
          <Alert
            onClose={handleClose}
            severity="error"
            elevation={6}
            variant="filled"
          >
            {mensaje_error}
          </Alert>
        </Slide>
      </Snackbar>
    </Fragment>
  );
}
